<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 24 24" :class="[`${prefix}-icon`, `${prefix}-icon-notification`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_8d45c85b51__a"><rect width="24" height="24" rx="0"/></clipPath></defs><g clip-path="url(#svg_8d45c85b51__a)" fill-rule="evenodd"><path d="M3.4007680000000002 15.8835Q5.69999 14.3807 5.69999 8.67647 5.69999 6.1180900000000005 7.5452 4.30905 9.390419999999999 2.4999999368892 11.99995 2.5 14.6095 2.500000567997 16.454700000000003 4.30905 18.2999 6.1180900000000005 18.2999 8.67647 18.2999 14.3807 20.5991 15.8835C21.0127 16.1538 21.1245 16.7016 20.8488 17.107100000000003 20.6818 17.352600000000002 20.4008 17.5 20.0999 17.5L3.899995 17.5C3.402942 17.5 3.0000000643727 17.105 3.0000000643727 16.6176 3.0000000643727 16.3226 3.15039 16.0471 3.4007680000000002 15.8835zM9.5 20.499556C9.5 20.69392 9.5525572 20.88406 9.651238 21.04672Q10.005451 21.70274 10.61535 22.09161 11.25586 22.5 12 22.5 12.74414 22.5 13.38465 22.09161 13.99455 21.70274 14.34876 21.04672C14.44744 20.88406 14.5 20.69392 14.5 20.499556 14.5 19.947517 14.08493 19.5 13.57291 19.5 13.21909 19.5 12.89613 19.717125 12.74042 20.059669Q12.49231 20.50488 12 20.50488 11.50769 20.50488 11.25958 20.059671C11.10387 19.717125 10.78091 19.5 10.427091 19.5 9.915073 19.5 9.5 19.947517 9.5 20.499556z"/></g></svg>
</template>
<script>

export default {
  name: 'IconNotification',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
